import { render, staticRenderFns } from "./TenancyDue.vue?vue&type=template&id=38c0ab2a"
import script from "./TenancyDue.vue?vue&type=script&lang=js"
export * from "./TenancyDue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports